import React, { useEffect, useState } from 'react'
import { Row, Col, Button, Space, Spin, Card, DatePicker } from 'antd'
import {
  DollarOutlined, UserAddOutlined, FireOutlined, CrownOutlined,
  VideoCameraOutlined, ShoppingCartOutlined, TeamOutlined, StarOutlined,
  RiseOutlined, RollbackOutlined, GiftOutlined, TrophyOutlined,
  LeftOutlined, RightOutlined,
} from '@ant-design/icons'
import { home } from '../../api'
import { useAuth } from '../../store/auth'
import dayjs, { Dayjs } from 'dayjs'

const KPI_CONFIG = [
  { key: 'gmv',             title: '今日GMV',       prefix: '¥', suffix: '',  icon: <DollarOutlined />,    color: 'blue' },
  { key: 'plan_orders',     title: '方案订单数',     prefix: '',  suffix: '单', icon: <ShoppingCartOutlined />, color: 'grey' },
  { key: 'paid_users',      title: '付费用户数',     prefix: '',  suffix: '人', icon: <FireOutlined />,      color: 'pink' },
  { key: 'new_users',       title: '新增用户',       prefix: '',  suffix: '人', icon: <UserAddOutlined />,   color: 'green' },
  { key: 'return_users',    title: '回流用户',       prefix: '',  suffix: '人', icon: <RollbackOutlined />,  color: 'teal' },
  { key: 'active_big_r',   title: '大R',            prefix: '',  suffix: '人', icon: <CrownOutlined />,     color: 'violet' },
  { key: 'member_gmv',     title: '会员收入',        prefix: '¥', suffix: '',  icon: <StarOutlined />,      color: 'gold' },
  { key: 'publish_experts', title: '发单专家数',     prefix: '',  suffix: '人', icon: <TeamOutlined />,      color: 'indigo' },
  { key: 'publish_plans',   title: '发布方案量',     prefix: '',  suffix: '个', icon: <RiseOutlined />,      color: 'cyan' },
  { key: 'reserve_experts', title: '预约直播专家数', prefix: '',  suffix: '人', icon: <VideoCameraOutlined />, color: 'yellow' },
  { key: 'live_experts',    title: '直播专家数',     prefix: '',  suffix: '人', icon: <TrophyOutlined />,    color: 'orange' },
  { key: 'card_gmv',        title: '专家次卡收入',   prefix: '¥', suffix: '',  icon: <GiftOutlined />,      color: 'rose' },
  { key: 'reward_gmv',      title: '专家打赏收入',   prefix: '¥', suffix: '',  icon: <GiftOutlined />,      color: 'purple' },
]

const PERSON_COLORS = ['#fff3cd','#d1ecf1','#f8d7da','#d4edda','#e2d6f3','#ffe5d0','#cfe8ff','#f5d4e8','#dbeed5','#fce4a6']
const WC_MEMBERS = ['芳芳','俊峰','佳鑫','李轶','毓泽','史雨鹏','郝天峥','佳林','子豪']
const WC_SHIFT_LABEL: Record<string,string> = {'夜班':'夜班 00-08','晨班':'晨班 04-13','早班':'早班 08-17','正常班':'正常班 09:30-19','特殊正常':'特殊正常 10-19','小晚班':'小晚班 14-23','晚班':'晚班 15-00','世界杯晚班':'世界杯晚班 16-01','新媒体小夜':'新媒体小夜 17-02','内容小夜':'内容小夜 19-03'}
const WORK_SHIFTS = ['夜班','晨班','早班','正常班','特殊正常','小晚班','晚班','世界杯晚班','新媒体小夜','内容小夜']
const KEY_MATCHES: Record<string,string[]> = {'2026-06-12':['墨西哥VS南非','韩国VS捷克'],'2026-06-13':['美国VS巴拉圭'],'2026-06-14':['巴西VS摩洛哥'],'2026-06-15':['德国VS库拉索','荷兰VS日本'],'2026-06-16':['西班牙VS佛得角','比利时VS埃及'],'2026-06-17':['法国VS塞内加尔','阿根廷VS阿尔及利亚'],'2026-06-18':['葡萄牙VS刚果','英格兰VS克罗地亚'],'2026-06-19':['墨西哥VS韩国'],'2026-06-20':['巴西VS海地'],'2026-06-21':['荷兰VS瑞典','德国VS科特迪瓦','突尼斯VS日本'],'2026-06-22':['西班牙VS沙特','比利时VS伊朗'],'2026-06-23':['阿根廷VS奥地利','法国VS伊拉克','挪威VS塞内加尔'],'2026-06-24':['英格兰VS加纳'],'2026-06-25':['苏格兰VS巴西','南非VS韩国'],'2026-06-26':['厄瓜多尔VS德国','日本VS瑞典'],'2026-06-27':['挪威VS法国','乌拉圭VS西班牙'],'2026-06-28':['巴拿马VS英格兰','哥伦比亚VS葡萄牙']}
const personColor = (name: string) => { const i = WC_MEMBERS.indexOf(name); return i < 0 ? '#eee' : PERSON_COLORS[i % PERSON_COLORS.length] }
const isKeyMatch = (dateStr: string, m: string) => { const keys = KEY_MATCHES[dateStr] || ['VS']; return keys.some(k => m.includes(k)) }

export default function HomePage() {
  const [kpi, setKpi] = useState<any>(null)
  const [wcData, setWcData] = useState<any[]>([])
  const [wcWeekOffset, setWcWeekOffset] = useState(0)
  const [selectedDate, setSelectedDate] = useState<Dayjs>(dayjs())
  const { user } = useAuth()

  const today = dayjs().format('YYYY-MM-DD')
  const isToday = selectedDate.format('YYYY-MM-DD') === today

  const wcWeekStart = dayjs().startOf('isoWeek').add(wcWeekOffset, 'week')
  const wcWeekEntries = wcData.filter(d => {
    const d0 = dayjs(d.dateStr)
    return d0.isSame(wcWeekStart, 'day') || (d0.isAfter(wcWeekStart) && d0.isBefore(wcWeekStart.add(7, 'day')))
  })
  const wcWeekNum = wcData.length > 0 && wcWeekEntries.length > 0
    ? Math.floor(wcData.findIndex(d => d.dateStr === wcWeekEntries[0].dateStr) / 7) + 1
    : 1

  useEffect(() => {
    fetch('/schedule-app/data.json?_=' + Date.now())
      .then(r => r.json())
      .then(d => { if (Array.isArray(d)) setWcData(d) })
      .catch(() => {})
  }, [])

  useEffect(() => {
    setKpi(null)
    home.kpi(selectedDate.format('YYYY-MM-DD')).then(setKpi).catch(() => {})
  }, [selectedDate])

  return (
    <div>
      {/* 欢迎语 + 日期选择 */}
      <div style={{ marginBottom: 20, display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <div style={{ fontSize: 22, fontWeight: 700, color: '#4A4A4A' }}>
            {isToday ? `Hi, ${user?.name || ''}，今日数据概览` : `数据概览 · ${selectedDate.format('MM月DD日')}`}
          </div>
          <div style={{ color: '#B9B9B9', fontSize: 13, marginTop: 4 }}>{selectedDate.format('YYYY年MM月DD日 dddd')}</div>
        </div>
        <Space size={8}>
          <Button size="small" onClick={() => setSelectedDate(dayjs().subtract(1, 'day'))}>昨天</Button>
          <DatePicker size="small" value={selectedDate} onChange={v => v && setSelectedDate(v)} allowClear={false} disabledDate={d => d.isBefore('2026-01-01') || d.isAfter(dayjs())} />
          {!isToday && <Button size="small" type="primary" onClick={() => setSelectedDate(dayjs())}>今天</Button>}
        </Space>
      </div>

      {/* KPI 数据概览 */}
      <div style={{ background: '#fff', borderRadius: 12, padding: '20px 0', boxShadow: '0 2px 8px #E8EAFC', display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))' }}>
        {KPI_CONFIG.map((c, i) => {
          const val = kpi ? Number(kpi[c.key] ?? 0) : null
          const diff = kpi ? Number(kpi[`${c.key}_diff`] ?? 0) : 0
          const isUp = diff > 0; const isDown = diff < 0
          return (
            <div key={c.key} style={{ padding: '12px 20px', borderRight: (i + 1) % 6 !== 0 ? '1px solid #F0F0F0' : 'none', borderBottom: i < KPI_CONFIG.length - 6 ? '1px solid #F0F0F0' : 'none' }}>
              <div style={{ fontSize: 12, color: '#999', marginBottom: 6 }}>{c.title}</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: '#333' }}>{val !== null ? `${c.prefix}${val.toLocaleString()}${c.suffix}` : <Spin size="small" />}</div>
              <div style={{ fontSize: 11, marginTop: 4, color: isUp ? '#f5222d' : isDown ? '#52c41a' : '#ccc' }}>{isUp ? `↑ +${diff.toLocaleString()}` : isDown ? `↓ ${diff.toLocaleString()}` : '较昨日 —'}</div>
            </div>
          )
        })}
      </div>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col span={24}>
          <Card
            title={<span style={{ fontWeight: 600 }}>⚽ 世界杯排班</span>}
            size="small"
            style={{ borderRadius: 12 }}
            bordered={false}
            extra={
              <Space size={4}>
                <Button size="small" type="text" icon={<LeftOutlined />} onClick={() => setWcWeekOffset(o => o - 1)} />
                <span style={{ fontSize: 12, color: '#6E6E6E', minWidth: 160, textAlign: 'center' }}>
                  第 {wcWeekNum} 周 ({wcWeekEntries[0]?.dayLabel?.split(' ')[0] || ''} - {wcWeekEntries[wcWeekEntries.length-1]?.dayLabel?.split(' ')[0] || ''})
                </span>
                <Button size="small" type="text" icon={<RightOutlined />} onClick={() => setWcWeekOffset(o => o + 1)} />
              </Space>
            }>
            {wcData.length === 0 ? <Spin /> : wcWeekEntries.length === 0 ? (
              <div style={{ color: '#ccc', textAlign: 'center', padding: 16 }}>该周暂无排班数据</div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: `repeat(${wcWeekEntries.length}, 1fr)`, gap: 6, overflowX: 'auto' }}>
                {wcWeekEntries.map((d: any) => {
                  const isKey = d.priority === 2
                  const borderColor = isKey ? '#ef4444' : '#ddd'
                  const headerBg = isKey ? 'linear-gradient(135deg,#7f1d1d,#991b1b)' : '#f8f9fa'
                  const headerColor = isKey ? '#fca5a5' : '#333'
                  const restPeople: string[] = d.shifts?.['休息'] || []
                  return (
                    <div key={d.dateStr} style={{ border: `1.5px solid ${borderColor}`, borderRadius: 8, overflow: 'hidden', minWidth: 0 }}>
                      {/* 日期头 */}
                      <div style={{ background: headerBg, padding: '5px 7px' }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: headerColor }}>{d.dayLabel}</div>
                        {isKey && <div style={{ fontSize: 10, color: '#fca5a5' }}>🔴 重点场次</div>}
                      </div>
                      {/* 赛程 */}
                      <div style={{ padding: '5px 6px', background: '#fff', fontSize: 11 }}>
                        {(d.matches as string[]).map((m: string, mi: number) => {
                          const km = isKeyMatch(d.dateStr, m)
                          return <div key={mi} style={{ color: km ? '#c62828' : '#666', fontWeight: km ? 600 : 400, marginBottom: 1 }}>{km ? '⭐ ' : ''}{m}</div>
                        })}
                      </div>
                      {/* 班次 */}
                      <div style={{ padding: '4px 6px', background: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
                        {WORK_SHIFTS.map((s, si) => {
                          const people: string[] = d.shifts?.[s] || []
                          return (
                            <div key={s} style={{ display: 'flex', alignItems: 'center', gap: 3, minHeight: 22, padding: '2px 0', borderTop: si === 0 ? 'none' : '1px solid #f0f0f0' }}>
                              <span style={{ fontSize: 9, color: '#aaa', minWidth: 52, flexShrink: 0, lineHeight: 1.2 }}>{WC_SHIFT_LABEL[s] || s}</span>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2, flex: 1 }}>
                                {people.map(name => (
                                  <span key={name} style={{ background: personColor(name), borderRadius: 8, padding: '1px 6px', fontSize: 11 }}>{name}</span>
                                ))}
                              </div>
                            </div>
                          )
                        })}
                        {/* 休息行 */}
                        {restPeople.length > 0 && (
                          <div style={{ display: 'flex', alignItems: 'center', gap: 3, marginTop: 3, paddingTop: 3, borderTop: '1px dashed #ddd' }}>
                            <span style={{ fontSize: 10, color: '#aaa', minWidth: 34 }}>休息</span>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                              {restPeople.map(name => (
                                <span key={name} style={{ background: personColor(name), opacity: 0.6, borderRadius: 8, padding: '1px 6px', fontSize: 11 }}>{name}</span>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })}
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  )
}
